import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "./system"
import { AllowedDomainId } from "../id"
import { DocumentSnapshotLike } from "../firestore"

export const AllowedDomainDocumentMeta = z.object({
  domain: z.string().trim().min(1).describe("ドメイン名"),
  is_regex: z.boolean().describe("domainが正規表現を含むか"),
})

export type AllowedDomainDocumentMeta = z.infer<typeof AllowedDomainDocumentMeta>

export const CreateAllowedDomainRequest = z.object({
  domain: z.string(),
  isRegex: z.boolean(),
})

export type CreateAllowedDomainRequest = z.infer<typeof CreateAllowedDomainRequest>

export const AllowedDomainDocumentBody = AllowedDomainDocumentMeta.extend({
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export type AllowedDomainDocumentBody = z.infer<typeof AllowedDomainDocumentBody>

export type AllowedDomainDocument = AllowedDomainDocumentBody & {
  id: AllowedDomainId
}

export class AllowedDomainDocuments {
  public static readonly ALLOWED_DOMAIN_MIN_LENGTH = 1
  public static readonly ALLOWED_DOMAIN_MAX_LENGTH = 255
  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): AllowedDomainDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: AllowedDomainId(doc.id),
      domain: data["domain"],
      is_regex: data["is_regex"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
